<sf-card>
    <div class="px-2" [formGroup]="form">
        <div class="row mt-1">
            <div class="col-12">
                <h3>Quote Costs</h3>
                <p class="text-body-secondary">Please enter the costs associated with this quote.</p>
            </div>
            <div class="col-12 my-2">
                <button
                    sfButton
                    color="primary"
                    size="sm"
                    tooltip="If enabled, the quote PDF will show price of £0.00."
                    tooltipContainer="body"
                    [icon]="form.get('freeOfCharge')?.value ? 'check-circle' : 'xmark-circle'"
                    [active]="form.get('freeOfCharge')?.value"
                    (click)="toggleFreeOfCharge()">
                    Free of Charge
                </button>
                <button
                    sfButton
                    color="primary"
                    size="sm"
                    tooltip="If enabled, the quote PDF will not show parts seperately. Parts & labour will be combined into a single line."
                    tooltipContainer="body"
                    [icon]="form.get('combinedLines')?.value ? 'check-circle' : 'xmark-circle'"
                    [active]="form.get('combinedLines')?.value"
                    (click)="toggleCombinedLines()">
                    Combined Parts & Labour
                </button>
            </div>
            <div class="col-12">
                <div class="row gx-2">
                    <div class="col-sm-3">
                        <div class="mb-2">
                            <sf-input-quantity
                                label="Labour Hours"
                                inputId="labourHours"
                                [step]="0.25"
                                [max]="100"
                                formControlName="labourHours"></sf-input-quantity>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="mb-2">
                            <sf-input-money
                                label="Labour Rate"
                                inputId="labourRate"
                                formControlName="labourRate"></sf-input-money>
                        </div>
                    </div>
                </div>
                <div class="row gx-2">
                    <div class="col-sm-6">
                        <div class="mb-2">
                            <sf-label for="discountPercentage" label="Discount %"></sf-label>
                            <ng-select
                                [items]="smartquoteHelperService.discountPercentages"
                                [clearable]="false"
                                formControlName="discountPercentage">
                                <ng-template ng-label-tmp let-item="item"> {{ item }}% </ng-template>
                                <ng-template ng-option-tmp let-item="item"> {{ item }}% </ng-template></ng-select
                            >
                        </div>
                        <div class="mb-2">
                            <sf-label for="vatPercentage" label="VAT Rate" [required]="true"></sf-label>
                            <ng-select
                                id="vatPercentage"
                                [items]="smartquoteHelperService.vatPercentages"
                                [clearable]="false"
                                bindLabel="display"
                                bindValue="value"
                                formControlName="vatMultiplier">
                            </ng-select>
                        </div>
                        <div class="mb-2">
                            <sf-input-money
                                label="Discount (exc. VAT)"
                                inputId="moneyOff"
                                formControlName="moneyOff"></sf-input-money>
                        </div>
                        <div class="mb-2">
                            <sf-label for="Deposit" label="Deposit"></sf-label>
                            <ng-select
                                [items]="smartquoteHelperService.depositPercentages"
                                formControlName="depositPercentage">
                                <ng-template ng-label-tmp let-item="item"> {{ item }}% </ng-template>
                                <ng-template ng-option-tmp let-item="item"> {{ item }}% </ng-template>
                            </ng-select>
                        </div>
                        <div class="mb-2"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-9">
                        <sf-input
                            description="This image will be used on the 'Landing Page' seen by the customer. When adding a part from the catalog and if the part has an image, click the image to copy the URL to this field."
                            label="Image Url"
                            inputId="defaultImageUrl"
                            formControlName="defaultImageUrl"></sf-input>
                    </div>
                    <div class="col-3">
                        @if (form.controls.defaultImageUrl.value) {
                            <img
                                class="img-fluid mt-2"
                                style="max-width: 80px"
                                [src]="form.controls.defaultImageUrl.value" />
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</sf-card>
